import { render, staticRenderFns } from "./DistributorData.vue?vue&type=template&id=45349c72&"
import script from "./DistributorData.vue?vue&type=script&lang=js&"
export * from "./DistributorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports